import { useQuery } from "@tanstack/react-query";
import { Button } from "@rumbledirect/ui";
import { Space } from "antd";
import { fetchServicepartners } from "../../../lib/api/resources/servicePartners";
import { servicepartnerColumns } from "./lib/constants/servicepartnerColumns";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useHasRole } from "../../../lib/helpers/roles";
import { Table } from "@/components/v2";
import { FileExcelOutlined } from "@ant-design/icons";
import { ServicepartnerFilterModal } from "./components/ServicepartnerFilterModal";
import { ServicepartnerFilterValues } from "./lib/types/ServicepartnerFilterValues.interface";
import { useUrlFilters } from "../dossiers/lib/urlState/useUrlFilters";
import { servicepartnerFilterFields } from "./lib/constants/servicepartnerFilterFields";
import { buildServicepartnerApiFilters } from "./lib/helpers/buildServicepartnerApiFilters";

export const ServicepartnerList = () => {
  const [page, setPage] = useState(1);
  const hasAdminRole = useHasRole("ROLE_OIDC_ADMIN");

  const filterKeys = servicepartnerFilterFields.map(
    (f) => f.name,
  ) as (keyof ServicepartnerFilterValues)[];

  const { filters, setFilters } = useUrlFilters<ServicepartnerFilterValues>({
    keys: filterKeys,
    paramPrefix: "d_",
    resetPageParam: "page", // atomic page reset on filter change
  });

  const setServicepartnerFilters = (
    filterValues: ServicepartnerFilterValues,
  ) => {
    setFilters(filterValues);
  };

  const servicepartnersQuery = useQuery({
    queryKey: ["servicepartners", page, filters],
    queryFn: () =>
      fetchServicepartners({
        page,
        ...buildServicepartnerApiFilters(filters),
      }),
  });

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Space
          size="middle"
          wrap
          style={{ width: "100%", justifyContent: "space-between" }}
        >
          <ServicepartnerFilterModal
            setServicepartnerFilters={setServicepartnerFilters}
            servicepartnerFilters={filters}
          />

          {hasAdminRole && (
            <Link to="/service-partners/partners/import">
              <Button icon={<FileExcelOutlined />}>Importeren</Button>
            </Link>
          )}
        </Space>
      </div>
      <div>
        <Table
          columns={servicepartnerColumns}
          dataSource={servicepartnersQuery.data?.member}
          loading={servicepartnersQuery.isLoading}
          pagination={{
            pageSize: 15,
            total: servicepartnersQuery.data?.totalItems,
            showSizeChanger: false,
            onChange: (page) => setPage(page),
          }}
          rowKey="id"
        />
      </div>
    </div>
  );
};
